import React, { useEffect, useState } from 'react';
import { floatingCardLayout } from './FloatingCardLayout';

export default function FloatingCardOverlay({ focusIndex, focusPos, label, contents }) {
  const [visible, setVisible] = useState(false);
  const [activeLabel, setActiveLabel] = useState(null);

  // Adjustable delay and animation timing
  const APPEAR_DELAY_MS = 250;
  const TRANSITION_DURATION_MS = 400;
  const OVERLAY_OPACITY = 0.92; // Opacity handle for overlay background

  useEffect(() => {
    let timeout;
    if (focusIndex !== null && label && contents[label]) {
      setVisible(false); // trigger hide immediately
      timeout = setTimeout(() => {
        setActiveLabel(label);
        setVisible(true);
      }, APPEAR_DELAY_MS);
    } else {
      setVisible(false);
      setActiveLabel(null);
    }
    return () => clearTimeout(timeout);
  }, [focusIndex, label]);

  if (!activeLabel || !contents[activeLabel]) return null;

  const layout = floatingCardLayout[activeLabel] || {};

  return (
    <div
      style={{
        position: 'absolute',
        top: layout.top || '20px',
        left: layout.left || '50%',
        transform: layout.transform || 'translate(-50%, 0)',
        marginLeft: `${layout.offsetX || 0}px`,
        marginTop: `${layout.offsetY || 0}px`,
        width: layout.width || 360,
        height: layout.height || 340,
        zIndex: 1000,
        background: `rgba(255,255,255,${OVERLAY_OPACITY})`,
        padding: '20px',
        borderRadius: '12px',
        overflowY: 'auto',
        boxShadow: 'inset 0 0 0 2px #ccc, 0 0 10px rgba(0,0,0,0.3)',
        fontFamily: 'sans-serif',
        fontSize: '14px',
        color: '#111',
        pointerEvents: 'auto',
        opacity: visible ? 1 : 0,
        transform: `${layout.transform || 'translate(-50%, 0)'} scale(${visible ? 1 : 0.85})`,
        transition: `opacity ${TRANSITION_DURATION_MS}ms ease, transform ${TRANSITION_DURATION_MS}ms ease`,
        transformOrigin: 'top center',
      }}
      className="inner-scroll-container"
    >
      <div style={{ lineHeight: '1.6' }}>
        <style>{`a { color: blue; text-decoration: underline; }`}</style>
        {contents[activeLabel]}
      </div>
    </div>
  );
}
